import { Injectable } from '@angular/core';
import { Observable, concatMap, map, mergeMap, switchMap } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';

export interface WeatherAndIcon {
  weather: any;
  icon: any;
}
 
@Injectable({
  providedIn: 'root',
})
export class WeatherService {
  OBPortalSvcURL = '';
  weatherkey = '';
  weatherURL = '';
 
  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}
 
  public getWeatherData(
    lat: number | undefined,
    long: number | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.weatherkey = this.appConfigService.weatherAPIKey;
    this.weatherURL = this.appConfigService.weatherURL;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      //'X-RapidAPI-Key': 'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74',
    });
    // headers.append(
    //   'X-RapidAPI-Key',
    //   'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74'
    // );
    //headers.append('X-RapidAPI-Host', 'weatherapi-com.p.rapidapi.com');
    return this.httpClient.get<any>(
      this.weatherURL +
        'key=' +
        this.weatherkey +
        '&q=' +
        lat +
        ',' +
        long +
        '&days=1',
 
      { headers: headers }
    );
  }
 
  public getWeatherIconData(
    lat: number | undefined,
    long: number | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
 
    this.weatherkey = this.appConfigService.weatherAPIKey;
    this.weatherURL = this.appConfigService.weatherURL;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      //'X-RapidAPI-Key': 'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74',
    });
    // headers.append(
    //   'X-RapidAPI-Key',
    //   'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74'
    // );
    //headers.append('X-RapidAPI-Host', 'weatherapi-com.p.rapidapi.com');
    return this.httpClient
      .get<any>(
        this.weatherURL +
          'key=' +
          this.weatherkey +
          '&q=' +
          lat +
          ',' +
          long +
          '&days=1',
 
        { headers: headers }
      )
      .pipe(
        // switchMap(res),
        map((res) => {
          return res;
        }),
        mergeMap((res) =>
          this.getWeatherIcon(res.current?.condition?.code, res.current?.is_day)
        )
      );
  }
  public getWeatherIcon(
    weathercode: Int16Array | undefined,
    dayind: Int16Array | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const WeatherInfo: JSON = <JSON>(<unknown>{
      weathercode: weathercode,
      dayind: dayind,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
 
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetWeatherIcon',
      JSON.stringify(WeatherInfo),
      { headers: headers }
    );
  }
  public getWeatherForecastData(
    city: string | undefined,
 
    forecastdate: string
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.weatherkey = this.appConfigService.weatherAPIKey;
    this.weatherURL = this.appConfigService.weatherURL;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      //'X-RapidAPI-Key': 'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74',
    });
    // headers.append(
    //   'X-RapidAPI-Key',
    //   'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74'
    // );
    //headers.append('X-RapidAPI-Host', 'weatherapi-com.p.rapidapi.com');
    return this.httpClient.get<any>(
      this.weatherURL +
        'key=' +
        this.weatherkey +
        '&q=' +
        city +
        '&days=1&dt=' +
        moment(forecastdate).format('YYYY-MM-DD'),
 
      { headers: headers }
    );
  }
  public getWeatherIconForecastData(
    city: string | undefined,

    forecastdate: string
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;

    this.weatherkey = this.appConfigService.weatherAPIKey;
    this.weatherURL = this.appConfigService.weatherURL;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      //'X-RapidAPI-Key': 'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74',
    });
    // headers.append(
    //   'X-RapidAPI-Key',
    //   'ac09916f54mshd7dc21a34d88491p1fcca6jsnac0e8b9e1f74'
    // );
    //headers.append('X-RapidAPI-Host', 'weatherapi-com.p.rapidapi.com');
    return this.httpClient
      .get<any>(
        this.weatherURL +
          'key=' +
          this.weatherkey +
          '&q=' +
          city +
          '&days=1&dt=' +
          moment(forecastdate).format('YYYY-MM-DD'),

        { headers: headers }
      )
      .pipe(
        // switchMap(res),
        map((res) => {
          return res;
        }),
        mergeMap((res) =>
          this.getWeatherIcon(res.current?.condition?.code, res.current?.is_day)
        )
      );
  }

  public getWeatherDataAndIcon(
    lat: number | undefined,
    long: number | undefined
  ): Observable<WeatherAndIcon> {
    return this.getWeatherData(lat, long).pipe(
      switchMap((weatherData) =>
        this.getWeatherIcon(weatherData.current?.condition?.code, weatherData.current?.is_day).pipe(
          map((iconData) => ({ weather: weatherData, icon: iconData }))
        )
      )
    );
  }

  public getWeatherForecastDataAndIcon(
    city: string | undefined,
    forecastdate: string
  ): Observable<WeatherAndIcon> {
    return this.getWeatherForecastData(city, forecastdate).pipe(
      switchMap((weatherData) =>
        this.getWeatherIcon(weatherData.current?.condition?.code, weatherData.current?.is_day).pipe(
          map((iconData) => ({ weather: weatherData, icon: iconData }))
        )
      )
    );
  }
}